<template>
  <h1>Contact Us Component</h1>
</template>

<script lang="ts" setup></script>
